export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      accessToken: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC9kZXYuaW5zcGVjdGlvbi5qaXcuY28uanBcL2FwaVwvdjFcL2xvZ2luXC91c2VyIiwiaWF0IjoxNTgzNzMzNjY1LCJleHAiOjE1ODM4MjAwNjUsIm5iZiI6MTU4MzczMzY2NSwianRpIjoiZW51MnliN09pVVpINWZmUyIsInN1YiI6MjcsInBydiI6IjIzYmQ1Yzg5NDlmNjAwYWRiMzllNzAxYzQwMDg3MmRiN2E1OTc2ZjcifQ.1PnsyFSJKU6l3citm1ZOb2OxsbbP9VTaA8Itc_5O28k_refgreshed',
      expireIn: 3600
    }
  }
}